module.exports = __webpack_public_path__ + "img/fishing.99c5e8c2.png";